"use client";

import { ArrowUpRight, Blocks, BrainCircuit, Lock } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
export default function ModuleBreakdown() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const pillars = [{
    number: "SLOTS AVAILABLE",
    title: "MARKETING FUNDAMENTALS",
    icon: BrainCircuit,
    description: "•Understanding markets and customers\n•Value proposition design\n• Market research and segmentation\n• Competitive positioning"
  }, {
    number: "02",
    title: "STRATEGIC MARKETING PLANNING",
    icon: Blocks,
    description: "•\nSocial media strategy\n•\nContent marketing and SEO basics"
  }, {
    number: "03",
    title: "BRANDING & CUSTOMER EXPERIENCE",
    icon: Lock,
    description: "• Building strong brands • Customer journey mapping\n•\nMeasuring campaign success\n•\nData-driven marketing decisions"
  }];
  return <section data-section-id="5200" id="module-breakdown" className="bg-background text-foreground py-32 md:py-50 px-6 md:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 mb-16 md:mb-24 transition-all duration-700 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="lg:col-span-4">
            <div className="flex flex-col gap-3">
              <span className="font-mono text-xs md:text-sm tracking-widest uppercase text-primary">COURSE 3</span>
              <div className="h-px w-16 bg-primary" />
            </div>
          </div>
          <div className="lg:col-span-8">
            <h2 className="font-default font-bold text-4xl sm:text-5xl md:text-6xl lg:text-[88px] leading-[0.95] tracking-tighter uppercase">MODULES BREAKDOWN</h2>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {pillars.map((pillar, i) => {
          const Icon = pillar.icon;
          return <PillarCard key={i} pillar={pillar} Icon={Icon} index={i} />;
        })}
        </div>
      </div>
    </section>;
}
function PillarCard({
  pillar,
  Icon,
  index
}: {
  pillar: {
    number: string;
    title: string;
    description: string;
  };
  Icon: React.ComponentType<{
    className?: string;
    strokeWidth?: number;
  }>;
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <div ref={ref} data-index={index} style={{
    transitionDelay: `${index * 100}ms`
  }} className={`transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
      <Card className="group relative h-full min-h-[480px] bg-card backdrop-blur-xl border border-border rounded-lg p-10 md:p-12 flex flex-col shadow-md hover:border-primary hover:shadow-4xl transition-all duration-500">
        {}
        <div className="font-mono text-5xl md:text-6xl font-light text-primary transition-transform duration-500 group-hover:scale-110 origin-left">
          {pillar.number}
        </div>

        {}
        <div className="h-px w-full bg-primary/20 mt-6 mb-10 group-hover:bg-primary transition-colors duration-500" />

        {}
        <Icon className="size-8 text-foreground/60 group-hover:text-primary transition-colors duration-500 mb-8" strokeWidth={1.5} />

        {}
        <h3 className="font-default font-bold text-2xl md:text-3xl uppercase tracking-tight mb-6 leading-tight">
          {pillar.title}
        </h3>

        {}
        <p className="font-serif text-base md:text-[18px] leading-relaxed text-muted-foreground mb-10 flex-grow">
          {pillar.description}
        </p>

        {}
        <div className="mt-auto">
          
        </div>
      </Card>
    </div>;
}